import { gql } from '@apollo/client';

export const GET_SETTLEMENT_IMPORT_TASKS = gql`
  query GetSettlementImportTasks {
    getSettlementImportTasks {
      id
      customer
      sourceFileName
      settlementMonth
      submitterName
      status
      rowCount
      successCount
      failCount
      failureReason
      resultFileName
      completedAt
      cancelledAt
      createdAt
    }
  }
`;

export const GET_SETTLEMENT_IMPORT_ERROR_REPORT_URL = gql`
  query GetSettlementImportErrorReportUrl($taskId: Long!) {
    getSettlementImportErrorReportUrl(taskId: $taskId)
  }
`;

export const GET_SETTLEMENT_DETAILS = gql`
  query GetSettlementDetails(
    $customer: String
    $date: Int
    $beginId: Long
    $pageSize: Int
    $trackingNumbers: [String!]
  ) {
    getSettlementDetails(
      customer: $customer
      date: $date
      beginId: $beginId
      pageSize: $pageSize
      trackingNumbers: $trackingNumbers
    ) {
      id
      settlementMonth
      settlementDate
      trackingNumber
      customerId
      courierId
      invoiceSerialNo
      senderZipcode
      destZipcode
      zone
      dimensionLength
      dimensionWidth
      dimensionHeight
      uomOfDimension
      actualWeight
      dimensionWeight
      billedWeight
      uomOfWeight
      currency
      orderCreateTime
      pickupScanTime
      billableEvent
      billableTriggerDate
      deliveredEvent
      deliveredAt
      freight
      surchargeList
      expenseSummarization
    }
  }
`;
